import { CatalogItem } from "@/types/supplier";

export const categoryMatches = (item: CatalogItem, categories: string[]): boolean => {
    const hasEmptyCategory = categories.find(category => category === '') === ''
    if (!item.itemGroup1 && !item.itemGroup2 && hasEmptyCategory) return true
    if (item.itemGroup1 && categories.includes(item.itemGroup1)) return true
    return !!(item.itemGroup2 && categories.includes(item.itemGroup2))
}
